module.exports = __webpack_public_path__ + "img/img_15@2x.ac6d59f3.png";